import Headroom from 'headroom.js/dist/headroom';


// Custom js code
export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $(window).bind("load", function() {
            // Fire AFTER page load
            /* ////////////////////////////////////////////////////////////////////////////// */
            /* HEADROOM.JS CODE */
            /* ////////////////////////////////////////////////////////////////////////////// */
            // Spacing for header/hero overlay
            var headerHeight = $('#main-header').outerHeight();
            var heroHeight = $('#main-hero').outerHeight();
            $('#main-hero').css("margin-top", headerHeight);
            // Headroom.js
            var header = document.querySelector("#main-header");
            var headroom = new Headroom(header, {
                "offset": heroHeight,
            });
            headroom.init();
        });

        $(document).on('click', '.hamburger', (e) => {
            e.preventDefault()
            $('.hamburger').toggleClass('is-active')
            $('body').toggleClass('nav-open')
        })
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js